import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  MaterialReactTable,
  MRT_ToggleDensePaddingButton,
  MRT_ToggleFiltersButton,
  MRT_FullScreenToggleButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table';
import {
  Avatar,
  AvatarGroup,
  Checkbox,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Tooltip,
  Typography
} from '@mui/material';
import {
  Box,
  Button,
  IconButton,
  Grid,
  TextField,
  Autocomplete,
  Paper
} from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import CloseIcon from '@mui/icons-material/Close';
import LocalPrintshopOutlinedIcon from '@mui/icons-material/LocalPrintshopOutlined';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { ToastContainer } from 'react-toastify';
import './CreateUser.css';
import {
  GetUsers,
  AgencyAdminGetProfile,
  GetUserRoles,
  CreateAgencyUser,
  GetAgencyLocations,
  ResendPassword,
  UploadUserProfileImage
} from '../../apis/Agency';
import { successToast, ErrorToast } from '../../components/Toasts';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import UploadIcon from '@mui/icons-material/Upload';
import { MetaTags } from 'react-meta-tags';
import { base_logo_url, base_url } from '../../apis/constants';
import { useIsMobile } from '../../components/IsMobileHook/IsMobileHook';
import AddLocations from '../Locations/AddLocations';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

// ── Shared design tokens (mirrors Carriers component) ──────────────────────────
const inputSx = {
  '& .MuiInputBase-root': { fontSize: 13, borderRadius: '8px' }
};

const footerCard = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1.5,
  background: '#fff',
  borderRadius: '12px',
  border: '1px solid #e2e8f0',
  p: 1.5,
  boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
};

const sectionCard = {
  background: '#fff',
  borderRadius: '12px',
  border: '1px solid #e2e8f0',
  p: 2.5,
  mb: 1.5,
  boxShadow: '0 1px 2px rgba(0,0,0,0.03)'
};

function FieldLabel({ label, required }) {
  return (
    <Typography
      variant='caption'
      sx={{
        fontWeight: 500,
        fontSize: 11.5,
        color: 'text.secondary',
        mb: 0.4,
        display: 'block'
      }}
    >
      {label}
      {required && <span style={{ color: '#D4537E', marginLeft: 2 }}>*</span>}
    </Typography>
  );
}

function UserManagement(props) {
  const actionFrom = props.location?.state?.from || '';
  const selecedUserForRole = props.location?.state?.selectedUser || null;
  const selecedUserLocations = props.location?.state?.agencyLocations || null;
  const AgencyID = useSelector(state => state.userDetails.agencyLoginID);
  const [createLocPermission, setCreateLocPermission] = useState(null);
  const [createLocDialog, setCreateLocDialog] = useState(false);
  const loggedInEmail = useSelector(state => state.userDetails.email);
  const UserIsAdmin = useSelector(state => state.userDetails.isAdmin);
  const userRolePermissions = useSelector(
    state => state.userDetails.userRolePermissionsArr
  );
  const [currentView, setCurrentView] = useState('list');
  const [phoneNumberValidError, setPhoneNumberValidError] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [createAgencyLoader, setCreateAgencyLoader] = useState(false);
  const options = ['Active', 'In-Active'];
  const [adminRoles, setAdminRoles] = useState(null);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [userProfileImg, setUserProfileImg] = useState('');
  const [adminActiveValue, setAdminActiveValue] = useState(options[0]);
  const [adminStatus, setAdminStatus] = useState(true);
  const [adminBase64Image, setAdminBase64Image] = useState(null);
  const [adminSimpleImage, setAdminSimpleImage] = useState(null);
  const [agencyLocations, setAgencyLocations] = useState(null);
  const [userLocations, setUserLocations] = useState([]);
  const [allUsers, setAllUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [shipmentsLoader, setShipmentsLoader] = useState(true);
  const [userPermissionsArr, setUserPermissionsArr] = useState(null);
  const [disableCreateUserBtn, setDisableCreateUserBtn] = useState(false);
  const [editedData, setEditedData] = useState(null);
  const [adminRoleValue, setAdminRoleValue] = useState({
    id: '',
    roleName: ''
  });

  const history = useHistory();

  useEffect(() => {
    const filteredCarrierPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Users'
    );
    const LocationsPermissions = userRolePermissions?.filter(
      items => items.permissionName === 'Locations'
    );
    setUserPermissionsArr(filteredCarrierPermissions);
    setCreateLocPermission(LocationsPermissions);
  }, [userRolePermissions]);

  const fetchUsers = () => {
    GetUsers(AgencyID)
      .then(response => {
        if (response.status === 200) {
          setShipmentsLoader(false);
          const filteredUsers = response?.data?.data?.filter(
            users => !users.isAdmin
          );
          setAllUsers(filteredUsers);
        }
      })
      .catch(err => {
        setShipmentsLoader(false);
        setAllUsers([]);
      });
  };

  const fetchAgencyLocations = () => {
    GetAgencyLocations(AgencyID, 0)
      .then(response => {
        if (response.status === 200) {
          const filteredData = response?.data?.data.map(
            ({ locationCarriers, ...rest }) => rest
          );
          setAgencyLocations(filteredData);
        }
      })
      .catch(err => console.log(err.message));
  };

  const fetchUserRoles = () => {
    GetUserRoles(AgencyID)
      .then(response => {
        if (response.status === 200) {
          let rolesData = response?.data?.data
            .filter(item => item.roleName !== 'Default')
            .reverse();
          setAdminRoles(rolesData);
          if (actionFrom === 'role-management' && selecedUserForRole) {
            handleEditUser(
              null,
              selecedUserForRole,
              rolesData,
              selecedUserLocations
            );
            setAdminRoleValue(rolesData[0]);
          }
        }
      })
      .catch(err => console.log(err.message));
  };

  useEffect(() => {
    fetchUsers();
    fetchUserRoles();
    fetchAgencyLocations();
  }, []);

  const handdleExistedUserValidation = () => {
    const errors = {};
    errors['emailError'] = 'User exist with this email try another one';
    setValidationErrors(errors);
    setDisableCreateUserBtn(false);
  };

  const handleSuccessCreateAgency = (ApiRes, id) => {
    setCreateAgencyLoader(false);
    successToast(
      id ? 'User updated successfully!' : 'User created successfully!'
    );
    setCurrentView('list');
    fetchUsers();
    setAdminSimpleImage('');
    setAdminBase64Image('');
    setAdminStatus('');
    setDisableCreateUserBtn(false);
    setSelectedUser('');
    setUserProfileImg('');
  };

  const handleCreateUserReq = () => {
    setCreateAgencyLoader(true);
    let createObj = {
      id: currentView === 'edit' ? selectedUser.id : 0,
      role: adminRoleValue.id,
      firstName,
      lastName,
      loginId: email,
      password: '',
      email,
      notes: '',
      agencyId: AgencyID,
      phoneNumber,
      status: adminStatus,
      assignedLocations: userLocations.map(obj => obj?.id),
      avatar: userProfileImg ? userProfileImg : selectedUser.avatar
    };
    CreateAgencyUser(createObj)
      .then(
        res =>
          res.status === 200 && handleSuccessCreateAgency(res, selectedUser.id)
      )
      .catch(err => {
        if (err?.response?.status === 409) {
          const errors = {};
          errors['emailError'] =
            err?.response?.data?.reasonPhrase ||
            'User exist with this email try another one';
          setValidationErrors(errors);
          setDisableCreateUserBtn(false);
          setCreateAgencyLoader(false);
          setSelectedUser('');
          setUserProfileImg('');
        } else {
          ErrorToast(err?.message);
          setCreateAgencyLoader(false);
          setDisableCreateUserBtn(false);
          setSelectedUser('');
          setUserProfileImg('');
        }
      });
  };

  const ValidatUserEmail = () => {
    setDisableCreateUserBtn(true);
    AgencyAdminGetProfile(email)
      .then(res => res.status === 200 && handdleExistedUserValidation())
      .catch(() => handleCreateUserReq());
  };

  const handlePhoneNumberPaste = event => {
    event.preventDefault();
    const pastedText = event.clipboardData.getData('text/plain');
    const cleanedText = pastedText.replace(/\D/g, '');
    const formattedValue = cleanedText.replace(
      /^(\d{3})(\d{3})(\d{4})$/,
      '($1) $2-$3'
    );
    setPhoneNumber(formattedValue);
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (phoneRegex.test(formattedValue)) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberError: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const handleSignUp = () => {
    let errors = {};
    if (!firstName) errors['firstNameError'] = 'Enter First Name';
    else if (!lastName) errors['lastNameError'] = 'Enter Last Name';
    else if (!email) errors['emailError'] = 'Enter Email';
    else if (!phoneNumber) errors['phoneNumberError'] = 'Enter Phone Number';
    else if (phoneNumberValidError)
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
    else if (!isValidEmail) errors['emailError'] = 'Enter Valid Email';
    else if (adminRoleValue.roleName === '')
      errors['roleName'] = 'Select user role';
    else if (userLocations.length === 0)
      errors['locationsError'] = 'Select Atleast One Location';
    else handleCreateUserReq();
    setValidationErrors(errors);
  };

  const handleResendEmailRequest = (event, rowData) => {
    event.stopPropagation();
    ResendPassword(rowData.loginId)
      .then(
        res => res.status === 200 && successToast('Email sent successfully!')
      )
      .catch(() => ErrorToast('Network Error'));
  };

  const userColumns = [
    {
      accessorFn: row => `${row.firstName} ${row.lastName}`,
      id: 'name',
      header: 'User Name',
      size: 10,
      Cell: ({ cell, row }) => (
        <>
          <Box
            sx={
              isMobile
                ? { display: 'flex', alignItems: 'center' }
                : { display: 'flex', alignItems: 'center', marginLeft: 3 }
            }
          >
            <AvatarGroup spacing='small'>
              <Avatar
                sx={{ bgcolor: 'ButtonFace', objectFit: 'contain', height: 40 }}
                imgProps={{ style: { height: 40 } }}
                src={base_logo_url + row.original.avatar}
              />
            </AvatarGroup>
            <span className='mx-0'>{cell.getValue()}</span>
          </Box>
          {!isMobile && (
            <div
              className={'table-row-buttons-users py-0'}
              style={{ marginLeft: '-4.5vw' }}
            >
              {((userPermissionsArr &&
                userPermissionsArr.filter(p => p.level4).length) ||
                UserIsAdmin) && (
                <button
                  onClick={event =>
                    handleResendEmailRequest(event, row.original)
                  }
                  className='bg-white border-0 p-2 fw-bold'
                >
                  <Tooltip title='Resend Password'>
                    <svg
                      fill='rgb(29,158,117)'
                      width='24px'
                      height='16px'
                      viewBox='0 0 64.00 64.00'
                      xmlns='http://www.w3.org/2000/svg'
                      stroke='rgb(29,158,117)'
                      strokeWidth='2.944'
                    >
                      <path d='M55.43,55.68H8.57a5.51,5.51,0,0,1-5.5-5.5V13.82a5.51,5.51,0,0,1,5.5-5.5H55.43a5.51,5.51,0,0,1,5.5,5.5V50.18A5.51,5.51,0,0,1,55.43,55.68ZM8.57,11.32a2.5,2.5,0,0,0-2.5,2.5V50.18a2.5,2.5,0,0,0,2.5,2.5H55.43a2.5,2.5,0,0,0,2.5-2.5V13.82a2.5,2.5,0,0,0-2.5-2.5Z' />
                      <path d='M32,27.21a2,2,0,0,1-.42-.05l-17.25-5a1.5,1.5,0,0,1,.84-2.89L32,24.15l16.83-4.88a1.5,1.5,0,0,1,.84,2.89l-17.25,5A2,2,0,0,1,32,27.21Z' />
                      <path d='M39.14,49a1.49,1.49,0,0,1-1.06-.44L34.9,45.34A1.51,1.51,0,0,1,36,42.77H51.82a1.5,1.5,0,0,1,0,3H39.59l.61.62a1.51,1.51,0,0,1,0,2.12A1.53,1.53,0,0,1,39.14,49Z' />
                      <path d='M36,45.77a1.5,1.5,0,0,1-1.06-2.56L38.08,40a1.5,1.5,0,1,1,2.12,2.12L37,45.34A1.48,1.48,0,0,1,36,45.77Z' />
                    </svg>
                  </Tooltip>
                </button>
              )}
              {((userPermissionsArr &&
                (userPermissionsArr.filter(p => p.level4).length ||
                  userPermissionsArr.filter(p => p.level2).length)) ||
                UserIsAdmin) && (
                <button
                  onClick={event => handleEditUser(event, row.original)}
                  className='mx-2 bg-white border-0 p-2 fw-bold'
                  style={{ color: '#1d9e75', borderRadius: '4px' }}
                >
                  <Tooltip title='View / Update'>
                    <svg
                      className='MX-1'
                      width='17'
                      height='17'
                      viewBox='0 0 13 13'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                        fill='#1d9e75'
                      />
                    </svg>
                  </Tooltip>
                </button>
              )}
            </div>
          )}
        </>
      )
    },
    {
      accessorKey: 'phone',
      id: 'phone',
      header: 'Phone Number',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span className='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'loginId',
      id: 'email',
      header: 'Email',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span className='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'roleName',
      id: 'role',
      header: 'Role',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <span className='mx-1'>{cell.getValue()}</span>
        </Box>
      )
    },
    {
      accessorKey: 'active',
      id: 'status',
      header: 'Status',
      size: 70,
      Cell: ({ cell }) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {cell.getValue() ? (
            <span
              className='mx-1'
              style={{ color: '#1d9e75', fontWeight: 600 }}
            >
              ACTIVE
            </span>
          ) : (
            <span className='mx-1 text-muted'>INACTIVE</span>
          )}
        </Box>
      )
    }
  ];

  const handlePrint = () => {};

  const handleAdminImageUpload = event => {
    const file = event.target.files[0];
    const reader = new FileReader();
    const imageType = /image.*/;
    if (!file?.type?.match(imageType)) {
      ErrorToast('Only image files are allowed');
      return;
    }
    reader.onloadend = () => setAdminSimpleImage(reader.result);
    reader.readAsDataURL(file);
    var formdata = new FormData();
    formdata.append('file', file);
    setDisableCreateUserBtn(true);
    UploadUserProfileImage(email ? email : loggedInEmail, formdata)
      .then(res => {
        res.status === 200 && setUserProfileImg(res.data.data);
        setDisableCreateUserBtn(false);
      })
      .catch(err => {
        setDisableCreateUserBtn(false);
        ErrorToast(err.message);
      });
  };

  const handleAdminStatusChange = (event, newValue) => {
    setAdminActiveValue(newValue);
    setAdminStatus(newValue === 'Active');
  };

  const handleAdminRoleChange = (event, newValue) => {
    setAdminRoleValue(newValue);
    setValidationErrors({ ...validationErrors, roleName: null });
  };

  const handleAdminLocationChange = (event, newValue) => {
    setUserLocations(newValue);
    setValidationErrors({ ...validationErrors, locationsError: null });
  };

  const handlePhoneNumberChange = event => {
    const inputValue = event.target.value;
    const formattedValue = inputValue
      .replace(/\D/g, '')
      .replace(/^(\d{3})(\d{3})(\d{4})$/, '($1) $2-$3');
    setPhoneNumber(formattedValue);
    const errors = {};
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    if (phoneRegex.test(formattedValue)) {
      setPhoneNumberValidError(false);
      setValidationErrors({ ...validationErrors, phoneNumberError: null });
    } else {
      setPhoneNumberValidError(true);
      errors['phoneNumberError'] = 'Enter Valid Phone Number (XXX) XXX-XXXX';
      setValidationErrors(errors);
    }
  };

  const handleEmailValidation = email => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const errors = {};
    setEmail(email);
    if (emailRegex.test(email)) {
      setIsValidEmail(true);
      setValidationErrors({ ...validationErrors, emailError: null });
    } else {
      setIsValidEmail(false);
      errors['emailError'] = 'Enter Valid Email';
    }
    setValidationErrors(errors);
  };

  const handleAddUser = () => {
    setFirstName('');
    setLastName('');
    setEmail('');
    setPhoneNumber('');
    setAdminActiveValue(options[0]);
    setAdminStatus(true);
    setUserLocations([]);
    setAdminRoleValue({ id: '', roleName: '' });
    setCurrentView('create');
  };

  const handleUserLocations = (userLocations, selecedUserLocations) => {
    let tempArr = [];
    for (let i = 0; i < userLocations.length; i++) {
      const locationId = userLocations[i].id;
      const filterdAssignedLocation = (
        agencyLocations ? agencyLocations : selecedUserLocations
      ).find(locations => locationId === locations.id);
      tempArr.push(filterdAssignedLocation);
    }
    setUserLocations(tempArr);
  };

  const handleEditUser = (event, rowData, rolesData) => {
    setCurrentView('edit');
    setEditedData(rowData ?? '');
    setSelectedUser(rowData ?? '');
    setFirstName(rowData.firstName ?? '');
    setLastName(rowData.lastName ?? '');
    setEmail(rowData.loginId ?? '');
    rowData.avatar && setAdminBase64Image(rowData.avatar);
    setPhoneNumber(rowData.phone ?? '');
    setAdminActiveValue(rowData.active ? 'Active' : 'In-Active');
    setAdminStatus(rowData.active ? true : false);
    setAdminRoleValue('');
    setUserLocations(selecedUserLocations ?? []);
    const selectedRoles = adminRoles ? adminRoles : rolesData;
    if (rowData.agencyId) {
      AgencyAdminGetProfile(rowData.loginId)
        .then(res => {
          if (res.status === 200) {
            setAdminRoleValue(
              selectedRoles.filter(
                role => role.id === res.data.data.userInfo.roleId
              )[0]
            );
            handleUserLocations(
              res.data.data.assignedLocations,
              selecedUserLocations
            );
          }
        })
        .catch(err => console.log(err.message));
    }
    if (event?.stopPropagation) event.stopPropagation();
  };

  const isMobile = useIsMobile();

  const handleClickOpen = () => setCreateLocDialog(true);
  const handleClose = button => {
    setCreateLocDialog(false);
    button === 'save' && fetchAgencyLocations();
  };
  function SectionHeader({ icon: Icon, title }) {
    return (
      <Box
        sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5, mt: 0.5 }}
      >
        <Icon sx={{ fontSize: 15, color: 'text.secondary' }} />
        <Typography
          variant='caption'
          sx={{
            fontWeight: 600,
            fontSize: 11,
            textTransform: 'uppercase',
            letterSpacing: '0.07em',
            color: 'text.secondary'
          }}
        >
          {title}
        </Typography>
        <Box sx={{ flex: 1, height: '0.5px', bgcolor: 'divider' }} />
      </Box>
    );
  }
  const isFormEditable =
    (userPermissionsArr &&
      ((userPermissionsArr.filter(p => p.level3).length && !editedData) ||
        (userPermissionsArr.filter(p => p.level4).length && editedData))) ||
    UserIsAdmin;

  // ── Reusable field check (same logic as before) ──────────────────────────────
  const canSave =
    (userPermissionsArr &&
      ((userPermissionsArr.filter(p => p.level3).length && !editedData) ||
        (userPermissionsArr.filter(p => p.level4).length && editedData)) &&
      !disableCreateUserBtn) ||
    (UserIsAdmin && !disableCreateUserBtn);

  // ── FORM (re-skinned to match Carriers) ──────────────────────────────────────
  const renderUserForm = () => (
    <Box
      sx={{
        background: '#f7fdf9',
        minHeight: '90vh',
        // px: isMobile ? 1.5 : 4,
        position: 'relative'
        // py: 3
      }}
    >
      {/* ── Header bar ── */}
      <Box
        sx={{
          maxWidth: 780,
          mx: 'auto',
          position: 'relative',
          height: 0
        }}
      >
        <IconButton
          onClick={() => {
            setCurrentView('list');
            setAdminSimpleImage('');
            setAdminBase64Image('');
            setEditedData(null);
            setValidationErrors({});
          }}
          sx={{
            position: 'absolute',
            right: 0,
            top: 12,
            color: '#D4537E',
            '&:hover': {
              bgcolor: 'rgba(212, 83, 126, 0.08)',
              transform: 'scale(1.05)'
            },
            transition: 'all 0.2s ease'
          }}
        >
          <CloseIcon fontSize='small' />
        </IconButton>
      </Box>

      <Box sx={{ maxWidth: 780, mx: 'auto', mt: 1 }}>
        {/* ── Avatar upload section ── */}
        <Box
          sx={{ ...sectionCard, display: 'flex', alignItems: 'center', gap: 3 }}
        >
          <Box>
            <input
              disabled={!isFormEditable}
              type='file'
              accept='image/*'
              onChange={handleAdminImageUpload}
              style={{ display: 'none' }}
              id='image-upload'
            />
            <label htmlFor='image-upload'>
              {adminBase64Image || adminSimpleImage ? (
                <Avatar
                  src={
                    adminSimpleImage
                      ? adminSimpleImage
                      : base_logo_url + adminBase64Image
                  }
                  sx={{
                    width: 72,
                    height: 72,
                    cursor: isFormEditable ? 'pointer' : 'default',
                    border: '2px solid #cceee3',
                    '& img': { objectFit: 'cover' }
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    background: '#e1f4ee',
                    border: '2px dashed #9dddc8',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: isFormEditable ? 'pointer' : 'default',
                    '&:hover': isFormEditable ? { background: '#cceee3' } : {}
                  }}
                >
                  <UploadIcon sx={{ color: '#1d9e75', fontSize: 20 }} />
                  <Typography
                    sx={{ fontSize: 9, color: '#1d9e75', fontWeight: 600 }}
                  >
                    Upload
                  </Typography>
                </Box>
              )}
            </label>
          </Box>
          <Box>
            <Typography
              sx={{ fontSize: 13, fontWeight: 700, color: '#0f3d2e' }}
            >
              Profile Photo
            </Typography>
            <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.3 }}>
              Upload a profile image (JPG, PNG)
            </Typography>
          </Box>
        </Box>

        {/* ── Personal Info section ── */}
        <Box sx={sectionCard}>
          <SectionHeader icon={PermIdentityIcon} title='Personal Information' />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FieldLabel label='First Name' required />
              <TextField
                fullWidth
                disabled={!isFormEditable}
                size='small'
                variant='outlined'
                error={Boolean(validationErrors['firstNameError'])}
                helperText={validationErrors['firstNameError']}
                onChange={e => {
                  const isValid = /^[A-Za-z\s\-]+$/.test(e.target.value);
                  (isValid || e.target.value === '') &&
                    setFirstName(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    firstNameError: null
                  });
                }}
                value={firstName}
                sx={inputSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FieldLabel label='Last Name' required />
              <TextField
                fullWidth
                disabled={!isFormEditable}
                size='small'
                variant='outlined'
                error={Boolean(validationErrors['lastNameError'])}
                helperText={validationErrors['lastNameError']}
                onChange={e => {
                  const isValid = /^[A-Za-z\s\-]+$/.test(e.target.value);
                  (isValid || e.target.value === '') &&
                    setLastName(e.target.value);
                  setValidationErrors({
                    ...validationErrors,
                    lastNameError: null
                  });
                }}
                value={lastName}
                sx={inputSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FieldLabel label='Email Address' required />
              <TextField
                fullWidth
                size='small'
                variant='outlined'
                error={Boolean(validationErrors['emailError'])}
                helperText={validationErrors['emailError']}
                onChange={e => handleEmailValidation(e.target.value)}
                value={email}
                disabled={
                  currentView === 'edit' && selectedUser.agencyId ? true : false
                }
                type='email'
                sx={inputSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FieldLabel label='Phone Number' required />
              <TextField
                fullWidth
                disabled={!isFormEditable}
                size='small'
                variant='outlined'
                error={Boolean(validationErrors['phoneNumberError'])}
                helperText={validationErrors['phoneNumberError']}
                onChange={handlePhoneNumberChange}
                onPaste={handlePhoneNumberPaste}
                value={phoneNumber}
                inputProps={{ maxLength: 14 }}
                placeholder='(XXX) XXX-XXXX'
                sx={inputSx}
              />
            </Grid>
          </Grid>
        </Box>

        {/* ── Account & Assignment section ── */}
        <Box sx={sectionCard}>
          <SectionHeader
            icon={ManageAccountsIcon}
            title='Account & Assignment'
          />

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FieldLabel label='Role' required />
              <Autocomplete
                disabled={!isFormEditable}
                fullWidth
                size='small'
                disableClearable
                value={adminRoleValue}
                onChange={(event, newValue) => {
                  if (newValue?.isButton) setCreateLocDialog(true);
                  else handleAdminRoleChange(event, newValue);
                }}
                renderOption={(props, option) => {
                  if (option.isButton) {
                    return (
                      <li
                        {...props}
                        key='create-role-button'
                        style={{ fontSize: 13 }}
                      >
                        <Button
                          fullWidth
                          sx={{
                            justifyContent: 'flex-start',
                            fontSize: '13px',
                            textTransform: 'none',
                            color: '#1d9e75'
                          }}
                          variant='text'
                          size='small'
                          onClick={e => {
                            e.stopPropagation();
                            history.push({
                              pathname: '/roles',
                              state: {
                                from: 'user-management',
                                selectedUser: {
                                  firstName,
                                  lastName,
                                  loginId: email,
                                  phone: phoneNumber,
                                  active: adminStatus
                                },
                                agencyLocations: userLocations
                              }
                            });
                          }}
                        >
                          + Create Role
                        </Button>
                      </li>
                    );
                  }
                  return (
                    <Box
                      component='li'
                      {...props}
                      key={option.id || option.roleName}
                      sx={{ fontSize: 13 }}
                    >
                      {option.roleName}
                    </Box>
                  );
                }}
                getOptionLabel={option => {
                  if (option.isButton) return '';
                  return option.roleName || '';
                }}
                options={[
                  {
                    isButton: true,
                    roleName: '+ Create Role',
                    id: 'create-role'
                  },
                  ...(adminRoles || [])
                ]}
                renderInput={params => (
                  <TextField
                    error={Boolean(validationErrors['roleName'])}
                    helperText={validationErrors['roleName']}
                    label=''
                    variant='outlined'
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: 13 }
                    }}
                    sx={inputSx}
                  />
                )}
                isOptionEqualToValue={(option, value) => {
                  if (option.isButton || value?.isButton) return false;
                  return option.id === value?.id;
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <FieldLabel label='Status' />
              <Autocomplete
                fullWidth
                disabled={!isFormEditable}
                size='small'
                disableClearable
                value={adminActiveValue}
                onChange={handleAdminStatusChange}
                renderOption={(props, option) => (
                  <Box style={{ fontSize: 13 }} {...props}>
                    {option}
                  </Box>
                )}
                options={options}
                renderInput={params => (
                  <TextField
                    label=''
                    variant='outlined'
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: 13 }
                    }}
                    sx={inputSx}
                  />
                )}
              />
            </Grid>

            <Grid item xs={12}>
              <FieldLabel label='Locations' required />
              <Autocomplete
                disabled={!isFormEditable}
                isOptionEqualToValue={(option, value) =>
                  option?.id === value?.id
                }
                multiple
                fullWidth
                disableCloseOnSelect
                size='small'
                disableClearable
                value={userLocations}
                onChange={(event, newValue) => {
                  const sall = newValue.filter(loc => loc.selectAll === true);
                  if (sall.length > 0) {
                    if (userLocations.length === agencyLocations.length)
                      handleAdminLocationChange(event, []);
                    else handleAdminLocationChange(event, agencyLocations);
                  } else {
                    handleAdminLocationChange(
                      event,
                      newValue.filter(loc => !loc.selectAll && !loc.isButton)
                    );
                  }
                }}
                renderOption={(props, option, { selected }) => {
                  const formatLocation = opt => {
                    if (!opt) return '';
                    if (opt.selectAll) return 'Select All';
                    if (opt.isButton) return '';
                    const rest = [
                      opt.city,
                      opt.state || opt.stateOrProvinceCode,
                      opt.postalCode,
                      opt.countryCode
                    ]
                      .filter(Boolean)
                      .join(' ');
                    return opt.name ? `${opt.name}: ${rest}` : rest;
                  };
                  if (option.isButton) {
                    if (
                      createLocPermission?.filter(p => p.level3).length ||
                      UserIsAdmin
                    ) {
                      return (
                        <li {...props} style={{ justifyContent: 'left' }}>
                          <Button
                            sx={{
                              ml: 2,
                              color: '#1d9e75',
                              textTransform: 'none'
                            }}
                            variant='text'
                            size='small'
                            onClick={e => {
                              e.stopPropagation();
                              setCreateLocDialog(true);
                            }}
                          >
                            + Create Location
                          </Button>
                        </li>
                      );
                    }
                    return null;
                  }
                  return (
                    <li {...props}>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
                        checkedIcon={
                          <CheckBoxIcon
                            fontSize='small'
                            sx={{ color: '#1d9e75' }}
                          />
                        }
                        style={{ marginRight: 8 }}
                        checked={
                          option.selectAll
                            ? userLocations.length === agencyLocations?.length
                            : selected
                        }
                      />
                      {formatLocation(option)}
                    </li>
                  );
                }}
                getOptionLabel={option => {
                  const formatLocation = opt => {
                    if (!opt) return '';
                    if (opt.selectAll) return 'Select All';
                    if (opt.isButton) return '';
                    const rest = [
                      opt.city,
                      opt.state || opt.stateOrProvinceCode,
                      opt.postalCode,
                      opt.countryCode
                    ]
                      .filter(Boolean)
                      .join(' ');
                    return opt.name ? `${opt.name}: ${rest}` : rest;
                  };
                  return formatLocation(option);
                }}
                options={
                  agencyLocations?.length === 0 || agencyLocations?.length === 1
                    ? [
                        { name: 'Create Location', isButton: true },
                        ...(agencyLocations || [])
                      ]
                    : agencyLocations?.length > 1
                      ? [
                          { name: 'Create Location', isButton: true },
                          { name: 'Select All', selectAll: true },
                          ...(agencyLocations || [])
                        ]
                      : []
                }
                renderInput={params => (
                  <TextField
                    required
                    multiline
                    label=''
                    variant='outlined'
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      style: { fontSize: 13 }
                    }}
                    error={Boolean(validationErrors['locationsError'])}
                    helperText={validationErrors['locationsError']}
                    sx={{
                      ...inputSx,
                      ...(userLocations.length > 2
                        ? {
                            '& .MuiInputBase-root': {
                              height: 'auto',
                              minHeight: 40,
                              fontSize: 13,
                              borderRadius: '8px'
                            }
                          }
                        : {})
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Box>

        {/* ── Action buttons ── */}
        <Box sx={footerCard}>
          <Button
            size='small'
            variant='outlined'
            onClick={() => {
              setCurrentView('list');
              setAdminSimpleImage('');
              setAdminBase64Image('');
              setEditedData(null);
              setValidationErrors({});
            }}
            sx={{
              borderRadius: '8px',
              borderColor: '#9dddc8',
              color: '#1d9e75',
              '&:hover': { borderColor: '#1d9e75', background: '#e1f4ee' }
            }}
          >
            Cancel
          </Button>
          <Button
            size='small'
            variant='contained'
            disabled={!canSave}
            onClick={handleSignUp}
            sx={{
              borderRadius: '8px',
              px: 3,
              background: '#1d9e75',
              '&:hover': { background: '#178a64' },
              '&.Mui-disabled': { background: '#9dddc8', color: '#fff' }
            }}
          >
            {createAgencyLoader ? 'Saving...' : 'Save Changes'}
          </Button>
        </Box>
      </Box>
    </Box>
  );

  // ── LIST VIEW ─────────────────────────────────────────────────────────────────
  const renderUserList = () => (
    <div className={isMobile ? 'mt-1 mx-2' : 'mt-2 mx-3'}>
      {adminRoles && (
        <MaterialReactTable
          state={{ isLoading: shipmentsLoader }}
          columns={userColumns}
          data={allUsers}
          enableRowSelection
          muiTableBodyRowProps={({ row }) => ({
            onClick: row.getToggleSelectedHandler()
          })}
          muiTableHeadCellFilterTextFieldProps={{ placeholder: '' }}
          muiTableContainerProps={{
            sx: { maxHeight: '70vh', minHeight: '70vh' }
          }}
          initialState={{ density: 'compact' }}
          positionToolbarAlertBanner='bottom'
          renderToolbarInternalActions={({ table }) => (
            <div style={isMobile ? { fontSize: 10 } : {}}>
              <MRT_ToggleGlobalFilterButton table={table} title='Search' />
              <IconButton title='Print' onClick={handlePrint}>
                <LocalPrintshopOutlinedIcon />
              </IconButton>
              <MRT_ToggleFiltersButton table={table} title='Filters' />
              <MRT_ToggleDensePaddingButton table={table} title='Spacing' />
              <MRT_ShowHideColumnsButton
                table={table}
                title='Show/Hide Columns'
              />
              <MRT_FullScreenToggleButton table={table} title='Fullscreen' />
              <Tooltip title='Clear All Filters' arrow>
                <IconButton
                  onClick={() => {
                    table.resetColumnFilters(true);
                    table.setShowColumnFilters(false);
                  }}
                >
                  <FilterAltOffIcon />
                </IconButton>
              </Tooltip>
            </div>
          )}
          enableRowActions={isMobile}
          renderRowActions={({ row }) => (
            <div>
              {((userPermissionsArr &&
                userPermissionsArr.filter(p => p.level4).length) ||
                UserIsAdmin) && (
                <button
                  onClick={event =>
                    handleResendEmailRequest(event, row.original)
                  }
                  className='bg-white border-0 p-2 fw-bold'
                >
                  <Tooltip title='Resend Password'>
                    <svg
                      fill='rgb(29,158,117)'
                      width='24px'
                      height='16px'
                      viewBox='0 0 64.00 64.00'
                      xmlns='http://www.w3.org/2000/svg'
                      stroke='rgb(29,158,117)'
                      strokeWidth='2.944'
                    >
                      <path d='M55.43,55.68H8.57a5.51,5.51,0,0,1-5.5-5.5V13.82a5.51,5.51,0,0,1,5.5-5.5H55.43a5.51,5.51,0,0,1,5.5,5.5V50.18A5.51,5.51,0,0,1,55.43,55.68ZM8.57,11.32a2.5,2.5,0,0,0-2.5,2.5V50.18a2.5,2.5,0,0,0,2.5,2.5H55.43a2.5,2.5,0,0,0,2.5-2.5V13.82a2.5,2.5,0,0,0-2.5-2.5Z' />
                      <path d='M32,27.21a2,2,0,0,1-.42-.05l-17.25-5a1.5,1.5,0,0,1,.84-2.89L32,24.15l16.83-4.88a1.5,1.5,0,0,1,.84,2.89l-17.25,5A2,2,0,0,1,32,27.21Z' />
                      <path d='M39.14,49a1.49,1.49,0,0,1-1.06-.44L34.9,45.34A1.51,1.51,0,0,1,36,42.77H51.82a1.5,1.5,0,0,1,0,3H39.59l.61.62a1.51,1.51,0,0,1,0,2.12A1.53,1.53,0,0,1,39.14,49Z' />
                      <path d='M36,45.77a1.5,1.5,0,0,1-1.06-2.56L38.08,40a1.5,1.5,0,1,1,2.12,2.12L37,45.34A1.48,1.48,0,0,1,36,45.77Z' />
                    </svg>
                  </Tooltip>
                </button>
              )}
              {((userPermissionsArr &&
                (userPermissionsArr.filter(p => p.level4).length ||
                  userPermissionsArr.filter(p => p.level2).length)) ||
                UserIsAdmin) &&
                row.original.roleName !== 'Default' && (
                  <button
                    onClick={event => handleEditUser(event, row.original)}
                    className='mx-2 bg-white border-0 p-2 fw-bold'
                    style={{ color: '#1d9e75', borderRadius: '4px' }}
                  >
                    <Tooltip title='View / Update'>
                      <svg
                        className='MX-1'
                        width='17'
                        height='17'
                        viewBox='0 0 13 13'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M1.33333 11.1693H2.26667L8.01667 5.41927L7.08333 4.48594L1.33333 10.2359V11.1693ZM10.8667 4.4526L8.03333 1.6526L8.96667 0.719271C9.22222 0.463715 9.53611 0.335938 9.90833 0.335938C10.2806 0.335938 10.5944 0.463715 10.85 0.719271L11.7833 1.6526C12.0389 1.90816 12.1722 2.21649 12.1833 2.5776C12.1944 2.93872 12.0722 3.24705 11.8167 3.5026L10.8667 4.4526ZM9.9 5.43594L2.83333 12.5026H0V9.66927L7.06667 2.6026L9.9 5.43594Z'
                          fill='#1d9e75'
                        />
                      </svg>
                    </Tooltip>
                  </button>
                )}
            </div>
          )}
          renderTopToolbarCustomActions={() => (
            <div
              style={
                isMobile
                  ? { display: 'flex', flexDirection: 'column-reverse' }
                  : { display: 'flex' }
              }
            >
              {((userPermissionsArr &&
                userPermissionsArr.filter(p => p.level3).length) ||
                UserIsAdmin) && (
                <Button
                  size='small'
                  onClick={handleAddUser}
                  className='m-2'
                  variant='contained'
                  sx={{
                    borderRadius: '8px',
                    fontSize: isMobile ? 10 : 13,
                    whiteSpace: 'nowrap',
                    background: '#1d9e75',
                    '&:hover': { background: '#178a64' }
                  }}
                >
                  Add User
                  <svg
                    className='ms-2'
                    width='11'
                    height='10'
                    viewBox='0 0 11 10'
                    fill='none'
                    xmlns='http://www.w3.org/2000/svg'
                  >
                    <path
                      d='M4.94531 9.72396V5.72396H0.945312V4.39062H4.94531V0.390625H6.27865V4.39062H10.2786V5.72396H6.27865V9.72396H4.94531Z'
                      fill='#fff'
                    />
                  </svg>
                </Button>
              )}
            </div>
          )}
        />
      )}
    </div>
  );

  return (
    <>
      <Dialog
        maxWidth='xl'
        PaperProps={{
          sx: {
            height: {
              xs: '100%',
              sm: 'auto',
              md: '45vh',
              lg: '45vh',
              xl: '45vh'
            },
            width: {
              xs: '100%',
              sm: 'auto',
              md: '84vw',
              lg: '84vw',
              xl: '84vw'
            },
            m: { xs: 1, sm: 2 }
          }
        }}
        open={createLocDialog}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle
          id='alert-dialog-title'
          sx={{ color: '#0f3d2e', fontWeight: 700 }}
        >
          Create Location
        </DialogTitle>
        <DialogContent>
          <DialogContentText id='alert-dialog-description'>
            <AddLocations locationFlow={'TL'} handleClose={handleClose} />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <MetaTags>
        <title>
          {base_url === 'https://beta.api.shiptechpro.com/'
            ? 'Users | Shiptechpro'
            : 'Users | TMS Shipping'}
        </title>
      </MetaTags>

      <ToastContainer
        style={
          isMobile
            ? { width: '100%', display: 'flex', justifyContent: 'center' }
            : { width: 'auto' }
        }
        position='top-center'
        autoClose={4800}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      {currentView === 'list' ? renderUserList() : renderUserForm()}
    </>
  );
}

export default UserManagement;
